/**
 * Enum for Feature Flag Ids
 * @readonly
 * @enum {name: {value: string}}
 */
export const LaunchDarklyFlagsEnum = Object.freeze({
  LDReadyWageHome: 'release_ReadyWageHome',
  LDReadyWageComputeLateandUT: 'release_ReadyWageComputeLateandUT',
  LDReadyCashViewStatements: 'release_RC_ViewStatements',
  LDReadyCashHome: 'release_RC_ReadyCashHome',
  LDReadyCashCreditLine: 'release_RC_CreditLine',
  LDReadyWage_PartnerDowntime: 'release_RW_BankPartnerDowntime',
});
